/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */

/**
 * Enum pour les Roles
 * @readonly
 * @enum { string }
 */
export enum AuthorizationRolesEnums {
  /** @type {string} */

  ROLE_SUPER_ADMIN = 'ROLE_SUPER_ADMIN',
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_SUPERVISOR = 'ROLE_SUPERVISOR',
  ROLE_GME = 'ROLE_GME',
  ROLE_CST = 'ROLE_CST',
  ROLE_OPERATEUR_EXPLOITATION = 'ROLE_OPERATEUR_EXPLOITATION',
  ROLE_GUEST = 'ROLE_GUEST',
  ROLE_SAE = 'ROLE_SAE',
  ROLE_TRANSURBAN = 'ROLE_TRANSURBAN',
}
/**
 * Enum pour les authorizations
 * @readonly
 * @enum { string } AuthorizationRightsEnums  -
 */
export enum AuthorizationRightsEnums {
  /** @type {string} */

  // Page accueil
  HOMEVIEWINCIDENTS = 'exploitation_home_view_incidents',
  HOMENAVIGATIONONGLET = 'exploitation_home_onglet_incident',
  HOMEQUALIFYINCIDENT = 'exploitation_qualify_incident',  // ok
  HOMEVIEWINCIDENTSDETAILS = 'exploitation_home_details_incident',

  // Page incidents
  INCIDENTFILEVIEWVIDEOLIVEINCIDENT = 'exploitation_details_live_video',
  INCIDENTFILEVIEWVIDEOREPLAYLIVEINCIDENT = 'exploitation_details_replay_live',
  INCIDENTFILEVIEWVIDEOREPLAYENDINCIDENT = 'exploitation_details_replay_end',
  INCIDENTFILEQUALIFYINCIDENT = 'exploitation_qualify_incident',  // ok
  INCIDENTFILEEXPORTERPDF = 'exploitation_details_download_pdf',
  INCIDENTFILEEXPORTERVIDEO = 'exploitation_details_download_sequence',

  // Page TMD / LAPI
  TMDLAPIVIEWLIST = 'exploitation_tmd_lapi_view_list',        // ok
  TMDLAPIEXPORTERPDF = 'exploitation_tmd_lapi_download_pdf',  // ok

  // Page Explorer
  EXPLORERVIEWLISTS = 'exploitation_explorer_lists',
  EXPLORERVIEWINCIDENTSDETAILS = 'exploitation_explorer_details_incident',
  EXPLOREREXPORTERPDF = 'exploitation_explorer_download_pdf',
  EXPLOREREXPORTERVIDEO =
      'exploitation_explorer_download_sequence',  // MAJ depuis le back
  EXPLORERFILTRERLETABLEAU = 'exploitation_explorer_filter',
  EXPLOREREXPORTERCSVLETABLEAU = 'exploitation_explorer_download_csv',

  // Page système
  SYSTEMVIEWTUBES = 'supervision_systeme_info_tubes',
  SYSTEMUPDATEDTUBES =
      'supervision_systeme_update_tubes',  // MAJ depuis le back
  SYSTEMREMOVETUBES =
      'supervision_systeme_delected_tubes',  // MAJ depuis le back

  // Page affichage  des incidents
  AFFICHAGEINCIDENTSPARAM = 'supervision_home_view_param',
  AFFICHAGEINCIDENTSPARAMUPDATE = 'supervision_home_update_param',
  AFFICHAGEUPDATESAE = 'supervision_home_update_sae',  // information back
  AFFICHAGESAE = 'supervision_home_connexion_sae',     // information back
  EXPORT_CSV_INFO_INCIDENTS = 'exploitation_explorer_csv_info_incident',
  EXPORT_CSV_INFO_VEHICLE = 'exploitation_explorer_csv_info_vehicle',

  // Page paramétrage des incidents MAJ
  INCIDENTSETTINGSVIEW = 'supervision_incident_view_param',
  INCIDENTUPDATEINHIBITION =
      'supervision_incident_update_inhibition',  // ok attention revoir
  // l'ensemble des pages
  INCIDENTSETTINGSRULES = 'supervision_incident_update_param',  // ok

  // Page liste des caméras
  CAMERALISTS = 'supervision_camera_lists',
  CAMERAALERTESTECHNIC = 'supervision_camera_alerts',
  CAMERAEXPORTERCSV = 'supervision_camera_download_csv',
  CAMERADETAILS = 'supervision_camera_details',
  CAMERADELECTED = 'supervision_camera_delete',  // ok
  CAMERAADDED = 'supervision_camera_add',        // ok
  CAMERAEDITEDFIELDS = 'supervision_camera_update_details',
  CAMERAEDITEDHIBITION = 'supervision_camera_update_inibition',  // ok
  CAMERASEGMENTATIONVIEW = 'supervision_camera_view_segment',    // ok
  CAMERASEGMENTATION = 'supervision_camera_update_segment',      // ok
  CAMERASTATIC = 'supervision_camera_view_state',
  CAMERAFLUXLIVE = 'supervision_camera_live_flow',

  // Page inhibition
  INHIBITIONVIEWLISTS = 'supervision_inhibition_lists',
  INHIBITIONCREATED = 'supervision_inhibition_add',      // ok
  INHIBITIONDELECTED = 'supervision_inhibition_delete',  // ok
  INHIBITIONSEECAMERASINHIBITION = 'supervision_inhibition_cameras',

  // Page simulateur
  SIMULATORCREATED = 'supervision_simulation_add',      // ok
  SIMULATORDELECTED = 'supervision_simulation_delete',  // ok

  // Page administration
  ADMINISTRATIONHOME = 'admin_home',                       // MAJ back
  ADMINISTRATIONUSERSLISTS = 'admin_users_lists',          // ok
  ADMINISTRATIONUSERSADDED = 'admin_users_add',            // ok
  ADMINISTRATIONUSERSUPDATED = 'admin_users_update_info',  // ok
  ADMINISTRATIONUSERSDELECTED = 'admin_users_delete',      // ok
  ADMINISTRATIONUSERVERSION = 'admin_version_acces',

  // Modale && menu && API
  CHANGEPASSWORD = 'supervision_users_update_password',
  TOOLSACCESS = 'supervision_outils_acces',                            // ok
  EXTRACTEDTHALESSEQUENCE = 'exploitation_details_download_sequence',  //

  // Page citilog
  CITILOGLISTS = 'supervision_citylog_acces',  // ok

  // Transurbain
  IS_TRANSURBAIN = 'is_transurban',
  SUPERVISION_SECTION_SHOW = 'supervision_section_show',
  EXPLOITATIOIN_EXPLORER_FILTER_QUALIFIED_SAE =
      'exploitation_explorer_filter_qualified_sae',
  EXPLOITATIOIN_EXPLORER_FILTER_QUALIFIED_WEB =
      'exploitation_explorer_filter_qualified_web',
  EXPLOITATIOIN_EXPLORER_FILTER_QUALIFIED_FILTER =
      'exploitation_explorer_filter_qualified_filter',
}



// WEBPACK FOOTER //
// ./src/apps/tunnel/enums/authorization/index.ts